import React, { useContext, useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import AppContainer from "../Components/Structure/AppContainer";
import ZegoLogs from "../Components/CallLogs/ZegoLogs";
import TwilioLogs from "../Components/CallLogs/TwilioLogs";
import { Toaster } from "react-hot-toast";
import ajaxCallStation from "../util/remote/ajaxCallStation";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ZegoVideoLogs from "../Components/CallLogs/ZegoVideoLogs";
import useStateCallback from "../util/customHooks/useStateCallback.js";
import CallsFilterForm from "../Components/Common/Statistics/CallsFilterForm.js";
import { Link } from "react-router-dom";
import CallContext from "../Context/CallContext.js";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function CallLogsPage() {

  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const todayFormatted = new Date().toLocaleDateString('en-US', options);
  const [callStatsToday, setCallStatsToday] = useState(false);
  const [callStatsOverall, setCallStatsOverall] = useState(false);
  const [modal, setModal] = useStateCallback(false);
  const [filteredStats, setFilteredStats] = useState(null);
  const [filterRange, setFilterRange] = useState(null);
  const {callHighlights} = useContext(CallContext);
  const statsData = filteredStats || callStatsOverall;
  const editedBusiestHour = callHighlights.busiest_hour?.hour > 12 ? `${callHighlights.busiest_hour?.hour - 12}pm` : `${callHighlights.busiest_hour?.hour}am`;
  const [loadingPage, setLoadingPage] = useState(true);
  // useEffect(() => {
  //     getCallStatsOverall();
  //     getCallStatsToday();

  // }, []);

  useEffect(() => {
    const fetchAll = async () => {
      setLoadingPage(true);
      await Promise.all([
        getCallStatsOverall(),
        getCallStatsToday()
      ]);
      setLoadingPage(false);
    };
  fetchAll();
  }, []);

  const getCallStatsOverall = async () => {
    const server_response = await ajaxCallStation.callStatisticsOverall();
    if (server_response.status === "OK") {
      setCallStatsOverall(server_response.details);
    } else {
      setCallStatsOverall(false);
    }
  };

  const getCallStatsToday = async () => {
    const server_response = await ajaxCallStation.callStatisticsToday();
    if (server_response.status === "OK") {
      setCallStatsToday(server_response.details);
    } else {
      setCallStatsToday(false);
    }
  };

  const filterStats = (e, item) => {
    setModal(false, () => setModal(<CallsFilterForm g={(data, range) => {
        setFilteredStats(data);
        setFilterRange(range);
      }} isOpen={true}/>));
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setFilteredStats(null);
    setFilterRange(null);
    
  };

  return (
    <AppContainer title="Call Logs">
      {modal}
      <Toaster position="top-center" reverseOrder={false} />
      {loadingPage ? (
              // Full page skeleton loader
              <div style={{ padding: 40 }}>
                <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                <Skeleton height={200} style={{ marginBottom: 20 }} />
                <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
              </div>
            ) : (<>
      <div className="row logtat">
            <div className="col-lg-12" style={{padding:0}}>
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card gradient-my-blue">
                  <div className="item-title mb-2" style={{color:"white"}}><b>STATISTICS </b></div>
                  <div className="row">
                    <div className="col-xl-4 col-lg-12 col-sm-4 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{callStatsOverall ? callStatsOverall.totals.buzz_voice.total.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Buzz Voice Calls</p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-12 col-sm-4 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{callStatsOverall ? callStatsOverall.totals.buzz_video.total.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Buzz Video Calls</p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-12 col-sm-4 pr-0 pl-0">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{callStatsOverall ? callStatsOverall.totals.gsm.total.total_p : "..."}</span></h2>
                        <p className="mb-0 text-light"> Direct Calls</p>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>                  
            </div>
            {/* <div className="col-lg-3" style={{paddingLeft:"10px"}}>
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card gradient-my-blue">
                  <div className="item-title mb-2" style={{color:"white"}}><b>CREDIT BALANCE </b></div>
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 col-sm-12 pr-0 pl-0">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">UGX. ...</span></h2>
                        <p className="mb-0 text-light"> Twilio Call Credit</p>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>                  
            </div> */}
          
      </div>
      
      <div className="row">
        <div className="col-lg-6">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card">
                  <div className="item-title">
                    <h5 style={{marginBottom:10}}>Statistics Today ({todayFormatted})</h5>
                  </div>
                  <div className="table-responsive">
                  <table className="table display data-table text-nowrap">
                    <tbody>
                    <tr>
                        <th>Call Type</th>
                        
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Completed</Tooltip>}>
                            <td ><i className="fa fa-phone" style={{color: "green"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Missed</Tooltip>}>
                        <td ><i className="fa fa-phone-slash" style={{color: "#DE3163"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Total</Tooltip>}>
                        <th ><i className="fa fa-equals" ></i></th></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Duration</Tooltip>}>
                        <th ><i className="fa fa-clock" style={{color:"black"}} ></i></th></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Cash Amount</Tooltip>}>
                        <th ><i className="fa fa-sack-dollar" style={{color: "black"}}></i></th></OverlayTrigger>
                      </tr>
                      <tr>
                        <td>Buzz Calls</td>
                        <td >{callStatsToday ? callStatsToday.totals.buzz_voice.completed.total_p : "..."}</td>
                        <td >{callStatsToday ? callStatsToday.totals.buzz_voice.missed.total_p : "..."}</td>
                        <td >{callStatsToday ? callStatsToday.totals.buzz_voice.total.total_p : "..."}</td>
                        <td >{callStatsToday ? callStatsToday.totals.buzz_voice.total_duration : "..."}</td>
                        <td> UGX. {callStatsToday? callStatsToday.totals.buzz_voice.amount.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Video Calls</td>
                        <td >{callStatsToday ? callStatsToday.totals.buzz_video.completed.total_p : "..."}</td>
                        <td >{callStatsToday ? callStatsToday.totals.buzz_video.missed.total_p : "..."}</td>
                        <td >{callStatsToday ? callStatsToday.totals.buzz_video.total.total_p : "..."}</td>
                        <td >{callStatsToday ? callStatsToday.totals.buzz_video.total_duration : "..."}</td>
                        <td> UGX. {callStatsToday? callStatsToday.totals.buzz_video.amount.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Direct Calls</td>
                        <td >{callStatsToday ? callStatsToday.totals.gsm.completed.total_p : "..."}</td>
                        <td >{callStatsToday ? callStatsToday.totals.gsm.missed.total_p : "..."}</td>
                        <td >{callStatsToday ? callStatsToday.totals.gsm.total.total_p : "..."}</td>
                        <td >{callStatsToday ? callStatsToday.totals.gsm.total_duration : "..."}</td>
                        <td> UGX. {callStatsToday? callStatsToday.totals.gsm.amount.total_p:"..."}</td>
                      </tr>
                      
                      
                    </tbody>
                  </table></div>
                </div>
              </div>
           
           
          
        </div>
        <div className="col-lg-6">
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body">
                  <div class="heading-layout1 mg-b-5">
                                     <div className="item-title">
                                      <h5 style={{marginBottom:10}}>Overall Call Statistics {filterRange && (
                      <span style={{ fontSize: "0.9rem", color: "#888" }}>
                        ({filterRange.startDate} to {filterRange.endDate})
                      </span>
                    )}</h5>
                                    </div>
                          <div class="dropdown">
                              
                            
                            <Link class="" onClick={resetFilter} role="button"><i class="fas fa-redo-alt ml-3"></i></Link>
                            <Link class="" onClick={filterStats} role="button"><i class="fas fa-filter ml-3"></i></Link>
                  
                           
                          </div>
                        </div>
                  <div className="table-responsive">
                  <table className="table display data-table text-nowrap">
                    <tbody>
                    <tr>
                        <th>Call Type</th>
                        
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Completed</Tooltip>}>
                            <td ><i className="fa fa-phone" style={{color: "green"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Missed</Tooltip>}>
                        <td ><i className="fa fa-phone-slash" style={{color: "#DE3163"}}></i></td></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Total</Tooltip>}>
                        <th ><i className="fa fa-equals" ></i></th></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Duration</Tooltip>}>
                        <th ><i className="fa fa-clock" style={{color:"black"}} ></i></th></OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={
                          <Tooltip id="refresh-tooltip">Cash Amount</Tooltip>}>
                        <th ><i className="fa fa-sack-dollar" style={{color: "black"}}></i></th></OverlayTrigger>
                      </tr>
                      <tr>
                        <td>Buzz Calls</td>
                        <td >{statsData ? statsData.totals.buzz_voice.completed.total_p : "..."}</td>
                        <td >{statsData ? statsData.totals.buzz_voice.missed.total_p : "..."}</td>
                        <td >{statsData ? statsData.totals.buzz_voice.total.total_p : "..."}</td>
                        <td >{statsData ? statsData.totals.buzz_voice.total_duration : "..."}</td>
                        <td> UGX. {statsData? statsData.totals.buzz_voice.amount.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Video Calls</td>
                        <td >{statsData ? statsData.totals.buzz_video.completed.total_p : "..."}</td>
                        <td >{statsData? statsData.totals.buzz_video.missed.total_p : "..."}</td>
                        <td >{statsData ? statsData.totals.buzz_video.total.total_p : "..."}</td>
                        <td >{statsData ? statsData.totals.buzz_video.total_duration : "..."}</td>
                        <td> UGX. {statsData? statsData.totals.buzz_video.amount.total_p:"..."}</td>
                      </tr>
                      <tr>
                        <td>Direct Calls</td>
                        <td >{statsData ? statsData.totals.gsm.completed.total_p : "..."}</td>
                        <td >{statsData? statsData.totals.gsm.missed.total_p : "..."}</td>
                        <td >{statsData ? statsData.totals.gsm.total.total_p : "..."}</td>
                        <td >{statsData ? statsData.totals.gsm.total_duration : "..."}</td>
                        <td> UGX. {statsData? statsData.totals.gsm.amount.total_p:"..."}</td>
                      </tr>
                      
                    </tbody>
                  </table></div>
                </div>
              </div>
            
           
         
         
        </div>
      </div>
      <div className="row">
      <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                  <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                      <Col sm={12}>
                        <Nav variant="pills" className="flex-row mb-1">
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="first">
                              Buzz Voice Calls{" "}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="second">
                              Buzz Video Calls{" "}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="third">
                              Direct Calls{" "}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="fourth">
                              Call Highlights{" "}
                            </Nav.Link>
                          </Nav.Item>
                          
                        </Nav>
                      </Col>
                      <Col sm={12}>
                        <Tab.Content>
                          <Tab.Pane eventKey="first">
                            <ZegoLogs/>
                          </Tab.Pane>
                          <Tab.Pane eventKey="second">
                            <ZegoVideoLogs/>
                          </Tab.Pane>
                          <Tab.Pane eventKey="third">
                            <TwilioLogs/>
                          </Tab.Pane>
                          
                          <Tab.Pane eventKey="fourth">
                           <div className="row">
                            <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                              <div className="text-center" style={{marginTop: "10px"}}>
                                <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-phone mr-1"></i> <span className="counter">Call Durations</span></h3>
                              </div>
                              <div className="row">
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.longest_buzz_call_duration:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> Longest Buzz Call</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.longest_gsm_call_duration:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> Longest Direct Call</p>
                                  </div>
                                </div>
                                 <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.average_buzz_call_duration:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> Average Buzz Call</p>
                                  </div>
                                </div>
                                 <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.average_gsm_call_duration:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> Average Direct Call</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center" style={{marginTop: "10px"}}>
                                <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-user mr-1"></i><span className="counter">Top Callers</span></h3>
                              </div>
                              <div className="row">
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.top_buzz_voice_caller?.caller_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {callHighlights? callHighlights.top_buzz_voice_caller?.call_count?.total_c:"..."} Buzz Voice Calls</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.longest_buzz_voice_caller?.caller_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {callHighlights? callHighlights.longest_buzz_voice_caller?.call_duration:"..."} on voice calls</p>
                                  </div>
                                </div>
                                 <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.top_gsm_caller?.caller_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark">{callHighlights? callHighlights.top_gsm_caller?.call_count?.total_c:"..."} Direct Calls</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.longest_gsm_caller?.caller_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {callHighlights? callHighlights.longest_gsm_caller?.call_duration:"..."} on direct calls</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.top_buzz_video_caller?.caller_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark">{callHighlights? callHighlights.top_buzz_video_caller?.call_count?.total_c:"..."} Video Calls</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.longest_buzz_video_caller?.caller_name:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {callHighlights? callHighlights.longest_buzz_video_caller?.call_duration:"..."} on video calls</p>
                                  </div>
                                </div>
                                 
                              </div>


                            </div>
                            <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0">
                              <div className="text-center" style={{marginTop: "10px"}}>
                                <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-calendar mr-1"></i><span className="counter">Record Days</span></h3>
                              </div>
                              <div className="row">
                                <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.completed_call_date?.call_date?.short_date:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {callHighlights? callHighlights.completed_call_date?.call_count?.total_c:"..."} Completed Calls</p>
                                  </div>
                                </div>
                                <div className="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.missed_call_date?.call_date?.short_date:"..."}</span></h5>
                                    <p className="mb-2 text-dark"> {callHighlights? callHighlights.missed_call_date?.call_count?.total_c:"..."} Missed Calls</p>
                                  </div>
                                </div>
                                 
                                 
                              </div>
                              <div className="text-center" style={{marginTop: "10px"}}>
                                <h3 className="mb-1 number-font" style={{color:"#042954"}}><i className="fe fe-trending-up mr-1"></i><span className="counter">Engagement Metrics</span></h3>
                              </div>
                              <div className="row">
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right mb-2">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? editedBusiestHour: "..."}</span></h5>
                                    <p className="mb-0 text-dark"> Busiest Hour</p>
                                    <p className="mb-2 text-dark"> {callHighlights? callHighlights.busiest_hour?.call_count?.total_c : "..."} Completed Calls</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 mb-2">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.call_streak_leader?.caller_name : "..."}</span></h5>
                                    <p className="mb-0 text-dark"> Consistent Caller</p>
                                    <p className="mb-2 text-dark"> {callHighlights? callHighlights.call_streak_leader?.streak_count?.total_p: "..."}-Day Streak</p>
                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right mb-2">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.missed_call_leader?.caller_name : "..."}</span></h5>
                                    <p className="mb-0 text-dark"> Missed Call Leader</p>
                                    <p className="mb-2 text-dark"> {callHighlights? callHighlights.missed_call_leader?.missed_count?.total_c: "..."} Missed Calls</p>

                                  </div>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-6 pr-0 pl-0 border-right">
                                  <div className="text-center">
                                    <h5 className="mb-1 number-font"><span className="counter">{callHighlights? callHighlights.non_caller_count?.total_p : "..."} Students</span></h5>
                                    <p className="mb-2 text-dark"> Non-Callers</p>

                                  </div>
                                </div>
                                
                                 
                                 
                              </div>


                            </div>
                    
                    
                    
                    
                          </div> 
                  
                          </Tab.Pane>
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container>  
                </div>
              </div>
          </div>
      </div></>
            )}
    </AppContainer>
  );
}

export default CallLogsPage;
